import { render, staticRenderFns } from "./VisitNumInfo.vue?vue&type=template&id=ed6379dc&scoped=true"
import script from "./VisitNumInfo.vue?vue&type=script&lang=js"
export * from "./VisitNumInfo.vue?vue&type=script&lang=js"
import style0 from "./VisitNumInfo.vue?vue&type=style&index=0&id=ed6379dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6379dc",
  null
  
)

export default component.exports